import styled, { css } from 'styled-components';
import { textH3, textSmall } from '@features/ui/styles/textStyles';

export const SubTitle = styled.div`
  ${textSmall};
  margin-bottom: 15px;
  text-transform: uppercase;
  color: var(--color-grey4);
`;

export const StyledTabTitle = styled.div<{ disabled?: boolean }>`
  color: var(--color-dark);
  ${({ disabled }) => disabled
    && css`
      color: var(--color-grey2);
    `}
  ${textH3}
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  align-items: center;
  height: 100%;
  justify-content: space-between;
  
  a {
    height: 100%;
    width: 100%;
  }
`;
